import React from 'react';
import { SearchBar } from '@fiverr-private/search_bar';
import { Container } from '@fiverr-private/layout_components';
import { useHeaderContext, HeaderContextValue } from '../../context/HeaderContext';

interface SearchProps {
    theme?: 'dark' | 'light';
    fullWidth?: boolean;
    show?: boolean;
    showAlways?: boolean;
    showOnMobile?: boolean;
}

export const Search = ({ theme = 'dark', fullWidth, show, showAlways, showOnMobile }: SearchProps) => {
    const {
        locale,
        abTests,
        user = {} as HeaderContextValue['user'],
        currency = {} as HeaderContextValue['currency'],
        rollouts = {} as HeaderContextValue['rollouts'],
        subCategoryId,
    } = useHeaderContext();

    return (
        <Container
            width={fullWidth ? '100%' : 'auto'}
            transition="opacity 250ms ease"
            visibility={
                showAlways
                    ? 'visible'
                    : { default: showOnMobile && show ? 'visible' : 'hidden', md: show ? 'visible' : 'hidden' }
            }
            opacity={showAlways ? '1' : show ? '1' : '0'} // eslint-disable-line no-nested-ternary
        >
            <SearchBar
                source="top-bar"
                locale={locale}
                userId={user.id}
                abTests={abTests}
                currency={currency}
                rollouts={rollouts}
                theme={theme}
                dimBackgroundEnabled
                subCategoryId={subCategoryId}
            />
        </Container>
    );
};
